import ReactGA from 'react-ga4';

const trackingId = 'G-3Y1YLFF7V5'; // Remplacez par votre ID de suivi
ReactGA.initialize(trackingId);

export const logPageView = () => {
  ReactGA.send('pageview');
};
